angular.module('mx.SolutionBuilderAgent').directive('mxHelp', mxHelpDirective);

mxHelpDirective.$inject = ['$compile', 'mx.internationalization'];

export function mxHelpDirective($compile, i18n) {
	return {
		require: { mxSidePanel: '?^^mxSidePanel' },
		controller: MxHelpController,
		controllerAs: 'mxHelpController',
		link: link,
	};

	function link(scope, element, attrs, ctrl) {
		const id = Math.random() * 10.0e16;

		const template = `
				<md-icon
					title="${i18n.get('shell.mx-help.title')}"
					class="material-icons mx-help"
					aria-hidden="true"
					tabindex="-1"
					ng-click="mxHelpController.showContent($event, ${!!ctrl.mxSidePanel})">
					help_outline
				</md-icon>`;

		const compiled = $compile(template)(scope);
		let containerTitle;

		compiled.prop('viewId', id);

		setTimeout(function () {
			if (element.is('md-slider')) {
				element.after(compiled);
			} else if (element.is('mx-checkbox')) {
				element.find('.md-label').after(compiled);
			} else if (element.is('.mx-literal') || element.find('> .mx-literal').length) {
				const label = element.find('label:visible');
				if (label.length > 0) {
					label.append(compiled);
				} else {
					element.find('.literal-value').after(compiled);
				}
			} else if (element.is('[mx-container]') && (containerTitle = element.find('> div > .panel-title')).length) {
				containerTitle.append(compiled);
			} else {
				element.append(compiled);
			}
		}, 1000);
	}
}

class MxHelpController {
	static $inject = ['mx.SolutionBuilderAgent.ViewHelpService'];

	constructor(viewHelpService) {
		this.viewHelpService = viewHelpService;
	}

	showContent(ev, calledFromSidePanel) {
		ev.stopPropagation();

		const target = angular.element(ev.target);
		const slider = target.siblings('md-slider');
		const isSlider = slider.length;
		const mxHelp = target.closest('[mx-help]');
		let content = mxHelp.attr('mx-help');

		if (isSlider) {
			content = slider.attr('mx-help');
		}

		this.viewHelpService.showHelpPopup(content, calledFromSidePanel);
	}
}
